import { IValuationData, ICode } from './ValuationWidget';
import { IStep } from './ValuationSteps';

const steps: IStep[] = [
    {
        name: 'start',
        trackingName: 'moin',
        title: 'Moin! Ich bin Rike und helfe Dir, Deine Immobilie in das Eigentümer-Dashboard aufzunehmen.',
        image: import('../../assets/img/Rike/Bild1.jpg'),
    },
    {
        name: 'code',
        trackingName: 'start',
        title: 'Welche Art von Immobilie möchtest Du beobachten?',
        image: import('../../assets/img/Rike/Bild2.jpg'),
        // description: 'Welche Art von Immobilie wollen Sie bewerten lassen?',
        // usedBy: [null, 'house', 'apartment'],
        options: { house: null, apartment: null },
    },
    // { name: 'contact', title: 'Kontaktadresse', description: 'Deine Kontaktdaten für die Immobilienbewertung.', usedBy: ['house', 'apartment'], isLast: true },

    {
        name: 'subcode',
        trackingName: 'haus|wohnung',
        title: 'Um welche Art {code} handelt es sich?',
        // description: 'Um welche Art von {code} handelt es sich?',
        image: import('../../assets/img/Rike/Bild6.jpg'),

        // usedBy: ['house', 'apartment'],
        options: {
            house: {
                house_detached: 'Einfamilienhaus',
                house_semi_detached: 'Doppelhaus\u00ADhälfte',
                house_row_middle: 'Reihenhaus - mittel',
                house_row_corner: 'Reihenhaus - Ecke',
                // house_farm: 'Bauernhaus',
            },
            apartment: {
                apartment_normal: 'Wohnung',
                apartment_maisonette: 'Maisonette',
                apartment_attic: 'Dachgeschoss',
                apartment_penthouse: 'Penthouse',
                apartment_terraced: 'Terrassen-Wohnung',
                apartment_studio: 'Studio',
            },
        },
    },
    {
        name: 'livingArea',
        trackingName: 'wohnflaeche',
        title: 'Wohnfläche',
        description: 'Wie groß ist die Wohnfläche {codeOf}?',
        image: import('../../assets/img/Rike/Bild13.jpg'),
        unit: 'm²',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 9999,
        validHint: 'Bitte nur Werte zwischen 0 und 9999 verwenden.',
    },
    {
        name: 'landArea',
        trackingName: 'grundstuecksflaeche',
        title: 'Grundstücksfläche',
        description: 'Wie groß ist das zugehörige Grundstück?',
        image: import('../../assets/img/Rike/Bild13.jpg'),
        unit: 'm²',
        usedBy: { code: ['house'] },
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 9999,
        validHint: 'Bitte nur Werte zwischen 0 und 9999 verwenden.',
    },
    {
        name: 'buildingYear',
        trackingName: 'baujahr',
        title: 'Baujahr',
        description: 'In welchem Jahr wurde {theCode} erbaut?',
        image: import('../../assets/img/Rike/Bild5.jpg'),
        decimalScale: 0,
        isValid: (nr: number) => Number.isInteger(Number(nr)) && Number(nr) >= 1800 && Number(nr) <= new Date().getFullYear() + 5,
        validHint: `Bitte nur ganze Werte zwischen 1800 und ${new Date().getFullYear() + 5} verwenden.`,
    },
    {
        name: 'numberOfRooms',
        trackingName: 'anzahlZimmer',
        title: 'Anzahl Zimmer',
        description: 'Wie viele Zimmer sind vorhanden?',
        tooltip: 'Als Zimmer zählen Wohn-, Schlaf-, Kinder- und Arbeitszimmer. Küche, Flur, Badezimmer und Abstellkammern etc. zählen nicht als Zimmer',
        image: import('../../assets/img/Rike/Bild7.jpg'),
        decimalScale: 1,
        isValid: (nr: number) => Number.isInteger(nr * 2) && nr >= 0 && nr <= 99,
        validHint: 'Bitte nur ganze  und *,5 Werte zwischen 0 und 99 verwenden.',
    },
    {
        name: 'numberOfBathrooms',
        trackingName: 'anzahlBaeder',
        title: 'Anzahl Bäder',
        description: 'Wie viele Bäder gibt es?',
        tooltip: 'Zähle hier alle Räume mit WC, nicht nur Vollbäder',
        image: import('../../assets/img/Rike/Bild7.jpg'),
        decimalScale: 0,
        isValid: (nr: number) => Number.isInteger(Number(nr)) && nr >= 0 && nr <= 99,
        validHint: 'Bitte nur ganze Werte zwischen 0 und 99 verwenden.',
    },
    {
        name: 'condition',
        trackingName: 'zustand',
        title: 'Zustand',
        description: 'In welchem Zustand befindet sich {theCode}?',
        image: import('../../assets/img/Rike/Bild3.jpg'),
        // usedBy: ['house', 'apartment'],
        options: {
            house: {
                renovation_needed: 'Renovierungsbedürftig',
                well_maintained: 'Gut gepflegt',
                new_or_recently_renovated: 'Neuwertig',
            },
            apartment: {
                renovation_needed: 'Renovierungsbedürftig',
                well_maintained: 'Gut gepflegt',
                new_or_recently_renovated: 'Neuwertig',
            },
        },
    },
    {
        name: 'features',
        trackingName: 'ausstattung',
        title: 'Ausstattung',
        description: 'Welche zusätzliche Ausstattung gehört {toCode}?',
        image: import('../../assets/img/Rike/Bild4.jpg'),
        // usedBy: ['house', 'apartment'],
        features: {
            house: { hasGarage: 'Garage', hasParkingSpace: 'Parkplatz/Carport' },
            apartment: { hasGarage: 'Garage', hasParkingSpace: 'Parkplatz/Carport' },
        },
    },
    {
        name: 'address',
        trackingName: 'adresse',
        title: 'Adresse',
        description: 'Für eine genaue Einschätzung benötigen wir die Adresse {codeOf}!',
        image: import('../../assets/img/Rike/Bild9.jpg'),
    },
    // {
    //     name: 'dealType',
    //     title: 'Miet oder Kaufpreis',
    //     description: 'Interessieren Sie sich für den Miet- oder Kaufpreis {codeOf}?',
    //     usedBy: ['house', 'apartment'],
    //     options: {
    //         house: { sale: 'Kaufpreis', rent: 'Miete' },
    //         apartment: { rent: 'Miete', sale: 'Kaufpreis' },
    //     },
    // },
    // {
    //     name: 'reason',
    //     title: 'Anfragegrund',
    //     description: 'Möchtest Du {theCode} kaufen, verkaufen, mieten oder vermieten?',
    //     image: import('../../assets/img/Rike/Bild10.jpg'),

    //     // usedBy: ['house', 'apartment'],
    //     options: {
    //         house: { buy: 'Kaufen', sell: 'Verkaufen', rent: 'Mieten', let: 'Vermieten' },
    //         apartment: { buy: 'Kaufen', sell: 'Verkaufen', rent: 'Mieten', let: 'Vermieten' },
    //     },
    // },
    // {
    //     name: 'estateAgent',
    //     title: 'Makler',
    //     description: 'Wünschst Du die Unterstützung eines Maklers?',
    //     image: import('../../assets/img/Rike/Bild10.jpg'),

    //     usedBy: { reason: ['sell'] },
    //     options: {
    //         house: { yes: 'Ja', maybe: 'Vielleicht', no: 'Nein' },
    //         apartment: { yes: 'Ja', maybe: 'Vielleicht', no: 'Nein' },
    //     },
    // },
    // {
    //     name: 'estateAgentNo',
    //     title: 'Unverbindlich anfragen!',
    //     description: 'Keine Sorge: Mit der Anfrage eines Maklers gehst Du keinerlei Verpflichtungen ein!',
    //     image: import('../../assets/img/Rike/Bild10.jpg'),

    //     usedBy: { reason: ['sell'], estateAgent: ['no'] },
    //     options: {
    //         house: { yes: 'Unverbindlich anfragen', no: 'Nicht anfragen' },
    //         apartment: { yes: 'Unverbindlich anfragen', no: 'Nicht anfragen' },
    //     },
    // },
    {
        name: 'precalc',
        trackingName: 'berechnung',
        title: 'Berechnung',
        description: 'Fast geschafft: Deine Angaben werden nun verarbeitet.',
        image: import('../../assets/img/Rike/Bild16.jpg'),
    },
    {
        name: 'loggedIn',
        trackingName: 'eingeloggt',
        // trackingName: 'login_register',
        title: 'Bitte melde Dich an oder registriere Dich!',
        // shortTitle: 'Login',
        image: import('../../assets/img/Rike/Bild15.jpg'),
        // required: true,
        // component: LoginRegister,
        // hasOwnForm: true
        isLast: true,
    },
    // {
    //     name: 'contact',
    //     title: 'Kontakt',
    //     description: 'Wohin sollen wir die Bewertung schicken?',
    //     image: import('../../assets/img/Rike/Bild15.jpg'),

    //     // usedBy: ['house', 'apartment', 'sell', 'buy', 'rent', 'let', 'yes', 'maybe', 'no'],
    //     isLast: true,
    // },
    // {
    //     name: 'score',
    //     title: 'Immobilienbewertung',
    //     description: 'Bitteschön! Hier findest Du die Bewertung Deiner Immobilie.',
    //     image: import('../../assets/img/Rike/Bild12.jpg'),
    // },
];

export default steps;
